import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import api from '../api/client'
import { useAuth } from '../auth'
import Loader from '../components/Loader'
import Pagination from '../components/Pagination'
import BannerCarrossel from '../components/BannerCarrossel'
import {
  Zap, Users, UserPlus, Activity, Cake, Briefcase, TrendingUp, Link2,
  Network, Share2, DollarSign, Leaf, Target, Trophy, BarChart3, ShoppingCart,
  Eye, EyeOff, Wallet, ShieldCheck, Banknote, Clock, PiggyBank,
} from 'lucide-react'

function load(key) { try { return JSON.parse(localStorage.getItem(key) || 'null') } catch { return null } }

const CARDS_LICENCIADOS = [
  { key: 'total_licenciados', label: 'Total Licenciados', icon: Briefcase, color: 'from-indigo-400 to-violet-400', textColor: 'text-indigo-700' },
  { key: 'novos_hoje', label: 'Novos Hoje', icon: UserPlus, color: 'from-blue-400 to-cyan-400', textColor: 'text-blue-700' },
  { key: 'licenciados_ativos', label: 'Licenciados Ativos', icon: Activity, color: 'from-emerald-400 to-teal-400', textColor: 'text-accent-700' },
  { key: 'aniversariantes_hoje', label: 'Aniversariantes', icon: Cake, color: 'from-amber-400 to-orange-400', textColor: 'text-amber-700' },
]
const CARDS_CLIENTES = [
  { key: 'total_clientes', label: 'Total Clientes', icon: Users, color: 'from-amber-400 to-orange-400', textColor: 'text-primary-700' },
  { key: 'novos_hoje', label: 'Novos Hoje', icon: UserPlus, color: 'from-blue-400 to-cyan-400', textColor: 'text-blue-700' },
  { key: 'clientes_ativos', label: 'Clientes Ativos', icon: Activity, color: 'from-violet-400 to-purple-400', textColor: 'text-violet-700' },
  { key: 'aniversariantes_hoje', label: 'Aniversariantes', icon: Cake, color: 'from-amber-400 to-orange-400', textColor: 'text-amber-700' },
]
const CARDS_LIC_OP = [
  { key: 'pv_pessoal', label: 'PV Pessoal', icon: Target, color: 'from-amber-400 to-orange-400', textColor: 'text-primary-700' },
  { key: 'conexoes_diretas_ativas', label: 'Diretas Ativas', icon: Link2, color: 'from-emerald-400 to-teal-400', textColor: 'text-accent-700' },
  { key: 'ativ5', label: 'Ativ5', icon: Network, color: 'from-indigo-400 to-violet-400', textColor: 'text-indigo-700' },
  { key: 'vme', label: 'VME', icon: BarChart3, color: 'from-blue-400 to-cyan-400', textColor: 'text-blue-700' },
]

function StatCard({ icon: Icon, label, value, color, textColor, prefix = '', onClick }) {
  return (
    <div onClick={onClick} role={onClick ? 'button' : undefined}
      className={`bg-white rounded-2xl p-4 sm:p-6 shadow-sm border border-gray-100 hover:shadow-lg hover:-translate-y-1 transition-all group ${onClick ? 'cursor-pointer' : ''}`}>
      <div className="flex items-start justify-between mb-3 sm:mb-4">
        <div className={`w-10 h-10 sm:w-12 sm:h-12 rounded-xl bg-gradient-to-br ${color} flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform`}>
          <Icon size={20} className="text-white" />
        </div>
        <TrendingUp size={16} className="text-primary-400 hidden sm:block" />
      </div>
      <p className="text-2xl sm:text-3xl font-heading font-bold text-gray-900">{prefix}{value ?? 0}</p>
      <p className={`text-xs sm:text-sm font-medium ${textColor} mt-1`}>{label}</p>
    </div>
  )
}

// Modal com TODOS os recebimentos confirmados (detalhe do card "Total Movimentado Asaas"):
// origem ASAAS (charge do gateway) ou Manual, mais recentes primeiro, paginação padrão do sistema.
function RecebimentosModal({ onClose }) {
  const [d, setD] = useState(null)
  const [page, setPage] = useState(1)
  const [size, setSize] = useState(20)
  const carregar = (p = 1, sz = size) => {
    api.get(`/financeiro/recebimentos?page=${p}&limit=${sz}`)
      .then((r) => { setD(r.data); setPage(p) })
      .catch(() => setD({ total_valor: 0, total: 0, pages: 1, data: [] }))
  }
  useEffect(() => { carregar(1) }, [])   // eslint-disable-line react-hooks/exhaustive-deps
  const money = (v) => 'R$ ' + Number(v || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2 })
  const dt = (s) => (s ? new Date(s).toLocaleString('pt-BR', { dateStyle: 'short', timeStyle: 'short' }) : '—')
  const TIPO = { licenca: 'Licença', renovacao: 'Renovação', recorrencia: 'Recorrência', pedido: 'Pedido' }
  return (
    <div className="fixed inset-0 z-[70] flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm" onClick={onClose}>
      <div className="bg-white rounded-2xl shadow-2xl max-w-3xl w-full max-h-[85vh] flex flex-col" onClick={(e) => e.stopPropagation()}>
        <div className="p-5 border-b border-gray-100 flex items-center justify-between">
          <div>
            <h3 className="font-heading font-extrabold text-graphite text-lg">Recebimentos confirmados</h3>
            {d && <p className="text-xs text-gray-500 mt-0.5">Total <b className="text-gray-800">{money(d.total_valor)}</b> · ASAAS {money(d.total_asaas)} · Manual {money(d.total_manual)} · {d.total} lançamento(s)</p>}
          </div>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600 text-xl leading-none px-2">×</button>
        </div>
        <div className="overflow-y-auto p-4 flex-1">
          {!d ? <p className="text-gray-400 text-sm py-8 text-center">Carregando...</p> : (
            <table className="w-full text-sm">
              <thead className="text-gray-400 text-xs uppercase text-left">
                <tr><th className="py-1.5 pr-2">Data</th><th className="py-1.5 pr-2">Descrição</th><th className="py-1.5 pr-2">Origem</th><th className="py-1.5 text-right">Valor</th></tr>
              </thead>
              <tbody>
                {(d.data || []).map((r, i) => (
                  <tr key={i} className="border-t border-gray-50">
                    <td className="py-2 pr-2 text-gray-500 text-xs whitespace-nowrap">{dt(r.data)}</td>
                    <td className="py-2 pr-2 text-gray-700">
                      <span className="text-[10px] uppercase font-bold text-gray-400 mr-1.5">{TIPO[r.tipo] || r.tipo}</span>{r.descricao}
                      <span className="block text-[10px] text-gray-400 truncate max-w-[280px]">{r.ref}</span>
                    </td>
                    <td className="py-2 pr-2">
                      <span className={`text-[10px] font-bold px-2 py-0.5 rounded-full ${r.origem === 'asaas' ? 'bg-blue-50 text-blue-700' : 'bg-amber-50 text-amber-700'}`}>
                        {r.origem === 'asaas' ? 'ASAAS' : 'MANUAL'}
                      </span>
                    </td>
                    <td className="py-2 text-right font-semibold text-emerald-600">{money(r.valor)}</td>
                  </tr>
                ))}
                {(d.data || []).length === 0 && <tr><td colSpan="4" className="py-8 text-center text-gray-400">Nenhum recebimento confirmado ainda.</td></tr>}
              </tbody>
            </table>
          )}
        </div>
        {d && d.total > 0 && (
          <div className="px-4 pb-3">
            <Pagination page={page} pages={d.pages || 1} total={d.total} pageSize={size}
              onPage={(p) => carregar(p)} onPageSize={(n) => { setSize(n); carregar(1, n) }} />
          </div>
        )}
      </div>
    </div>
  )
}

// Histórico expansível "Últimos recebimentos ASAAS" (widget ao lado do card Não distribuído):
// mostra hoje/últimos movimentos do gateway — Recebido (pago) ou Registrado para cobrança.
function UltimosAsaas() {
  const [open, setOpen] = useState(true)   // inicia EXPANDIDO (clique no cabeçalho retrai)
  const [d, setD] = useState(null)
  useEffect(() => { api.get('/financeiro/asaas/ultimos?limit=12').then((r) => setD(r.data)).catch(() => setD({ data: [], hoje_qtd: 0, hoje_total: 0 })) }, [])
  const money = (v) => 'R$ ' + Number(v || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2 })
  const hora = (s) => (s ? new Date(s).toLocaleString('pt-BR', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' }) : '—')
  return (
    <div onClick={() => setOpen((v) => !v)} role="button"
      className={`bg-white rounded-2xl p-4 sm:p-5 shadow-sm border border-gray-100 hover:shadow-lg transition-all cursor-pointer ${open ? 'sm:col-span-2' : ''}`}>
      <div className="flex items-start justify-between">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-sky-400 to-blue-500 flex items-center justify-center shadow-lg">
            <Clock size={18} className="text-white" />
          </div>
          <div>
            <p className="text-sm font-semibold text-gray-800">Últimos recebimentos ASAAS</p>
            <p className="text-xs text-gray-500">{d ? <>hoje: <b>{d.hoje_qtd}</b> mov. · recebido {money(d.hoje_total)}</> : 'carregando...'}</p>
          </div>
        </div>
        <span className="text-gray-400 text-lg leading-none select-none">{open ? '▾' : '▸'}</span>
      </div>
      {open && d && (
        <div className="mt-3 border-t border-gray-100 pt-2 max-h-64 overflow-y-auto" onClick={(e) => e.stopPropagation()}>
          {(d.data || []).map((r, i) => (
            <div key={i} className="flex items-center gap-2 py-1.5 border-b border-gray-50 text-xs">
              <span className="text-gray-400 whitespace-nowrap w-20">{hora(r.data)}</span>
              <span className="flex-1 text-gray-700 truncate">{r.descricao}</span>
              <span className={`text-[10px] font-bold px-2 py-0.5 rounded-full whitespace-nowrap ${r.status === 'recebido' ? 'bg-emerald-50 text-emerald-700' : 'bg-amber-50 text-amber-700'}`}>
                {r.status === 'recebido' ? 'RECEBIDO' : 'REGISTRADO P/ COBRANÇA'}
              </span>
              <span className="font-semibold text-gray-800 whitespace-nowrap">{money(r.valor)}</span>
            </div>
          ))}
          {(d.data || []).length === 0 && <p className="text-gray-400 text-xs py-3 text-center">Nenhum movimento ASAAS ainda.</p>}
        </div>
      )}
    </div>
  )
}

function SectionTitle({ icon: Icon, children }) {
  return (
    <h3 className="text-sm font-semibold text-gray-500 uppercase tracking-wider mb-3 flex items-center gap-2">
      <Icon size={16} /> {children}
    </h3>
  )
}

export default function Dashboard() {
  const { user, impersonating } = useAuth()
  const nav = useNavigate()
  const perfil = user?.perfil || 'admin'
  const isAdmin = perfil === 'admin'
  const isLic = perfil === 'licenciado'
  const lic = load('licenciado')
  const [showReceb, setShowReceb] = useState(false)
  const [licStats, setLicStats] = useState(null)
  const [cliStats, setCliStats] = useState(null)
  const [resumo, setResumo] = useState(null)
  const [finResumo, setFinResumo] = useState(null)
  const [loading, setLoading] = useState(true)
  const [ocultar, setOcultar] = useState(() => { try { return localStorage.getItem('tc_ocultar_saldo') === '1' } catch { return false } })

  useEffect(() => {
    setLoading(true); setLicStats(null); setCliStats(null)
    const jobs = []
    if (isAdmin) {
      jobs.push(api.get('/clientes/dashboard/stats').then((r) => setCliStats(r.data)).catch(() => {}))
      jobs.push(api.get('/licenciados/dashboard/stats').then((r) => setLicStats(r.data)).catch(() => {}))
    } else if (isLic) {
      jobs.push(api.get('/licenciados/dashboard/stats').then((r) => setLicStats(r.data)).catch(() => {}))
      jobs.push(api.get('/comissoes/resumo').then((r) => setResumo(r.data)).catch(() => {}))
      jobs.push(api.get('/financeiro/resumo').then((r) => setFinResumo(r.data)).catch(() => {}))
    } else {
      jobs.push(api.get('/clientes/dashboard/stats').then((r) => setCliStats(r.data)).catch(() => {}))
    }
    Promise.all(jobs).finally(() => setTimeout(() => setLoading(false), 300))
  }, [perfil, impersonating])

  if (loading) {
    return <div className="flex items-center justify-center h-[60vh]"><Loader size="lg" text="Carregando dashboard..." /></div>
  }

  const toggleOcultar = () => { const v = !ocultar; setOcultar(v); try { localStorage.setItem('tc_ocultar_saldo', v ? '1' : '0') } catch { /* */ } }
  const M = (v) => (ocultar ? 'R$ ••••••' : 'R$ ' + Number(v || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2 }))
  const avatarUrl = user?.avatar_url || lic?.foto_url || lic?.avatar_url || null
  const inicial = (user?.nome || 'L').charAt(0).toUpperCase()

  const nome = (user?.nome || '').split(' ')[0]
  const subtitle = isAdmin
    ? 'Bem-vindo ao painel de gestão The Conect Energy. Acompanhe licenciados, clientes e comissões.'
    : isLic
      ? 'Bem-vindo ao seu painel. Acompanhe seus clientes, rede, indicados e comissões.'
      : 'Bem-vindo ao The Conect Energy.'

  const acoes = isLic
    ? [
        { label: 'Meus Clientes', icon: Users, path: '#/cadastro/clientes', color: 'primary' },
        { label: 'Fazer Pedido', icon: ShoppingCart, path: '#/registros/pedidos', color: 'violet' },
        { label: 'Meu Link / Loja', icon: Share2, path: '#/meu-link', color: 'amber' },
        { label: 'Meus Ganhos', icon: DollarSign, path: '#/relatorios/comissoes', color: 'blue' },
      ]
    : isAdmin
      ? [
          { label: 'Novo Licenciado', icon: Briefcase, path: '#/cadastro/licenciados', color: 'primary' },
          { label: 'Novo Cliente', icon: Users, path: '#/cadastro/clientes', color: 'violet' },
          { label: 'Produtos', icon: ShoppingCart, path: '#/cadastro/produtos', color: 'amber' },
          { label: 'Comissões', icon: DollarSign, path: '#/relatorios/comissoes', color: 'blue' },
        ]
      : [
          { label: 'Meus Dados', icon: Users, path: '#/cadastro/clientes', color: 'primary' },
          { label: 'Materiais', icon: Leaf, path: '#/material', color: 'violet' },
        ]
  // classes estáticas por cor (evita classes dinâmicas que o Tailwind não gera)
  const ACAO = {
    primary: 'bg-primary-50 border-primary-100 hover:bg-primary-100',
    violet: 'bg-violet-50 border-violet-100 hover:bg-violet-100',
    amber: 'bg-amber-50 border-amber-100 hover:bg-amber-100',
    blue: 'bg-blue-50 border-blue-100 hover:bg-blue-100',
  }
  const ACAO_ICON = {
    primary: 'text-primary-600', violet: 'text-violet-600', amber: 'text-amber-600', blue: 'text-blue-600',
  }

  return (
    <div className="space-y-8">
      {/* Banner premium (licenciado) */}
      {isLic ? (
        <div className="tc-hero rounded-3xl p-6 sm:p-7 relative overflow-hidden shadow-xl">
          <div className="absolute top-0 right-0 w-72 h-72 bg-accent-500/10 rounded-full -translate-y-1/3 translate-x-1/3" />
          <div className="relative z-10 flex flex-col lg:flex-row lg:items-center gap-5">
            <div className="flex items-center gap-4 flex-1">
              {avatarUrl
                ? <img src={avatarUrl} alt="" className="w-16 h-16 rounded-2xl object-cover border-2 border-accent-300" />
                : <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-accent-500 to-accent-600 text-white flex items-center justify-center text-2xl font-heading font-bold shadow-lg">{inicial}</div>}
              <div>
                <p className="text-gray-500 text-sm">Bem-vindo de volta,</p>
                <h1 className="text-xl sm:text-2xl font-heading font-bold leading-tight text-graphite">{user?.nome}</h1>
                <span className="inline-flex items-center gap-1 mt-1 bg-accent-500/15 text-accent-700 px-2.5 py-0.5 rounded-full text-xs font-bold"><Trophy size={12} /> {licStats?.status_carreira || 'Consultor'}</span>
                {impersonating && <span className="ml-2 inline-flex items-center gap-1 bg-graphite/10 text-graphite px-2 py-0.5 rounded-full text-[11px] font-semibold"><Zap size={11} /> simulação</span>}
              </div>
            </div>
            <div className="flex items-center gap-4 flex-wrap">
              <div className="text-right">
                <p className="text-gray-500 text-[11px] uppercase tracking-wide font-semibold flex items-center gap-1 justify-end">
                  Disponível p/ saque
                  <button onClick={toggleOcultar} className="text-gray-400 hover:text-gray-600">{ocultar ? <EyeOff size={13} /> : <Eye size={13} />}</button>
                </p>
                <p className="text-2xl sm:text-3xl font-heading font-bold text-graphite">{M(finResumo?.saldo_disponivel)}</p>
                <p className="text-gray-500 text-[11px]">Total já sacado: {M(finResumo?.total_sacado)}</p>
              </div>
              <div className="flex flex-col gap-2">
                <a href="#/financeiro/carteira" className="bg-accent-500 text-white px-4 py-2 rounded-xl text-sm font-bold shadow hover:bg-accent-600 transition-colors flex items-center gap-1.5"><Banknote size={15} /> Realizar Saque</a>
                <a href="#/relatorios/extrato" className="text-accent-700 text-xs font-semibold underline text-center">Histórico de Saques</a>
              </div>
            </div>
          </div>
          {lic?.codigo_indicacao && <p className="relative z-10 mt-3 text-gray-500 text-xs flex items-center gap-1"><Share2 size={12} className="text-accent-600" /> Seu código: <b className="text-graphite">{lic.codigo_indicacao}</b></p>}
        </div>
      ) : (
      <div className="tc-hero rounded-2xl p-6 sm:p-8 relative overflow-hidden shadow-lg">
        <div className="absolute top-0 right-0 w-64 h-64 bg-accent-500/8 rounded-full -translate-y-1/2 translate-x-1/2" />
        <div className="absolute bottom-0 left-20 w-32 h-32 bg-accent-500/8 rounded-full translate-y-1/2" />
        <div className="relative z-10">
          <div className="flex items-center gap-3 mb-2">
            <span className="w-11 h-11 rounded-xl bg-gradient-to-br from-accent-500 to-accent-600 flex items-center justify-center shadow-lg flex-shrink-0"><Zap size={22} className="text-white" /></span>
            <h1 className="text-xl sm:text-2xl font-heading font-bold text-graphite">Olá, {nome}!</h1>
          </div>
          <p className="text-gray-600 text-sm max-w-lg">{subtitle}</p>
          {isLic && lic?.codigo_indicacao && (
            <div className="mt-4 inline-flex items-center gap-2 bg-accent-500/10 px-4 py-2 rounded-xl border border-accent-300">
              <Share2 size={16} className="text-accent-600" /><span className="text-sm font-bold text-graphite">Código: {lic.codigo_indicacao}</span>
            </div>
          )}
          {impersonating && (
            <div className="mt-4 ml-2 inline-flex items-center gap-2 bg-amber-400/25 px-4 py-2 rounded-xl border border-amber-400/40">
              <Zap size={16} className="text-amber-600" /><span className="text-sm font-semibold text-graphite">Modo simulação: {user?.nome}</span>
            </div>
          )}
        </div>
      </div>
      )}

      {/* Admin: Licenciados + Clientes */}
      {isAdmin && (
        <>
          <div>
            <SectionTitle icon={Briefcase}>Licenciados</SectionTitle>
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-5">
              {CARDS_LICENCIADOS.map((c) => <StatCard key={c.key} {...c} value={licStats?.[c.key]} onClick={() => nav('/cadastro/licenciados')} />)}
            </div>
          </div>
          <div>
            <SectionTitle icon={Users}>Clientes</SectionTitle>
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-5">
              {CARDS_CLIENTES.map((c) => <StatCard key={c.key} {...c} value={cliStats?.[c.key]} onClick={() => nav('/cadastro/clientes')} />)}
            </div>
          </div>
          {licStats?.estrategico && (
            <div>
              <SectionTitle icon={BarChart3}>Visão Estratégica · exclusivo administração</SectionTitle>
              <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-5">
                <StatCard icon={DollarSign} label="MRR (recorrência/mês)" value={`R$ ${(licStats.estrategico.mrr || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}`} color="from-emerald-400 to-teal-400" textColor="text-accent-700" onClick={() => nav('/financeiro/painel')} />
                <StatCard icon={TrendingUp} label="ARR (anual projetado)" value={`R$ ${(licStats.estrategico.arr || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}`} color="from-indigo-400 to-violet-400" textColor="text-indigo-700" onClick={() => nav('/financeiro/admin')} />
                <StatCard icon={Target} label="Comissão Prevista (rede)" value={`R$ ${(licStats.estrategico.comissao_prevista_rede || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}`} color="from-amber-400 to-orange-400" textColor="text-primary-700" onClick={() => nav('/financeiro/tesouraria')} />
                <StatCard icon={Trophy} label="Comissão Paga (rede)" value={`R$ ${(licStats.estrategico.comissao_paga_rede || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}`} color="from-blue-400 to-cyan-400" textColor="text-blue-700" onClick={() => nav('/financeiro/tesouraria')} />
                <StatCard icon={Banknote} label="Total Movimentado Asaas" value={`R$ ${(licStats.estrategico.total_movimentado_asaas ?? licStats.estrategico.total_movimentado ?? 0).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}`} color="from-teal-400 to-emerald-500" textColor="text-teal-700" onClick={() => setShowReceb(true)} />
                {licStats.estrategico.nao_distribuido !== undefined && licStats.estrategico.nao_distribuido !== null && (
                  <StatCard icon={PiggyBank} label="Não distribuído na rede" value={`R$ ${(licStats.estrategico.nao_distribuido || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}`} color="from-lime-300 to-green-400" textColor="text-green-700" onClick={() => nav('/financeiro/admin')} />
                )}
                <UltimosAsaas />
              </div>
            </div>
          )}
          {showReceb && <RecebimentosModal onClose={() => setShowReceb(false)} />}
        </>
      )}

      {/* Carrossel de campanhas (PRD 'Ajuste final') */}
      {isLic && <BannerCarrossel />}

      {/* Licenciado: Minha Operação + Qualificação + Meus Ganhos */}
      {isLic && (
        <>
          <div>
            <SectionTitle icon={Briefcase}>Minha Operação</SectionTitle>
            <div className="grid grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-5">
              <StatCard icon={Target} label="Volume Pessoal (PV)" value={licStats?.pv_pessoal ?? 0} color="from-amber-400 to-orange-400" textColor="text-primary-700" />
              <StatCard icon={Network} label="Volume de Grupo (GV)" value={licStats?.gv ?? 0} color="from-indigo-400 to-violet-400" textColor="text-indigo-700" />
              <StatCard icon={Link2} label="Diretas Ativas" value={licStats?.conexoes_diretas_ativas ?? 0} color="from-emerald-400 to-teal-400" textColor="text-accent-700" />
            </div>
          </div>

          <div className="bg-white rounded-2xl p-5 shadow-sm border border-gray-100">
            <div className="flex items-center justify-between flex-wrap gap-2 mb-3">
              <div>
                <p className="text-xs text-gray-500 uppercase tracking-wide">Status de Carreira</p>
                <p className="text-xl font-heading font-bold text-gray-900 flex items-center gap-2"><Trophy size={18} className="text-amber-500" /> {licStats?.status_carreira || '—'}</p>
              </div>
              <div className="text-right">
                <p className="text-xs text-gray-500 uppercase tracking-wide">Qualificação do mês</p>
                <p className="text-sm font-semibold text-gray-700">{licStats?.qualificacao || '—'}</p>
              </div>
            </div>
            {licStats?.proxima_faixa ? (
              <>
                <div className="flex justify-between text-xs text-gray-500 mb-1">
                  <span>Progresso · próximo nível: <b>{licStats.proxima_faixa}</b></span>
                  <span>{licStats.progresso_proxima ?? 0}%</span>
                </div>
                <div className="w-full h-2.5 bg-gray-100 rounded-full overflow-hidden cursor-help"
                  title={`Volume Total: ${(licStats.volume_qualificavel ?? 0).toLocaleString('pt-BR')} pts · Meta ${licStats.proxima_faixa}: ${(licStats.proxima_meta_pv ?? 0).toLocaleString('pt-BR')} pts`}>
                  <div className="h-full bg-gradient-to-r from-amber-400 to-accent-500 rounded-full transition-all" style={{ width: `${licStats.progresso_proxima ?? 0}%` }} />
                </div>
                <p className="text-[11px] text-gray-400 mt-1">Meta do nível {licStats.proxima_faixa}: {(licStats.proxima_meta_pv ?? 0).toLocaleString('pt-BR')} pts · seu Volume Total: <b>{(licStats.volume_qualificavel ?? 0).toLocaleString('pt-BR')} pts</b> (passe o mouse na barra)</p>
              </>
            ) : <p className="text-xs text-gray-400">Faixa máxima de volume atingida.</p>}
          </div>

          <div>
            <div className="flex items-center justify-between mb-3">
              <SectionTitle icon={DollarSign}>Meus Ganhos</SectionTitle>
              <button onClick={toggleOcultar} className="text-xs text-gray-400 hover:text-gray-700 flex items-center gap-1">{ocultar ? <EyeOff size={14} /> : <Eye size={14} />} {ocultar ? 'Mostrar' : 'Ocultar'} saldo</button>
            </div>
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-5">
              <StatCard icon={DollarSign} label="Bônus do Mês (prévia)" value={M(resumo?.previa)} color="from-amber-400 to-orange-400" textColor="text-amber-700" />
              <StatCard icon={Wallet} label="Saldo Disponível" value={M(finResumo?.saldo_disponivel)} color="from-emerald-400 to-teal-400" textColor="text-accent-700" />
              <StatCard icon={TrendingUp} label="Total de Ganhos" value={M(resumo?.total_geral)} color="from-indigo-400 to-violet-400" textColor="text-indigo-700" />
              <StatCard icon={Banknote} label="Saques Realizados" value={M(finResumo?.total_sacado)} color="from-gray-400 to-gray-500" textColor="text-gray-700" />
            </div>
          </div>
        </>
      )}

      {/* Cliente */}
      {!isAdmin && !isLic && (
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-5">
          {CARDS_CLIENTES.map((c) => <StatCard key={c.key} {...c} value={cliStats?.[c.key]} />)}
        </div>
      )}

      {/* Ações Rápidas + Ecossistema */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="bg-white rounded-2xl p-6 shadow-sm border border-gray-100">
          <h3 className="text-lg font-heading font-semibold text-gray-900 mb-4">Ações Rápidas</h3>
          <div className="grid grid-cols-2 gap-3">
            {acoes.map((a) => (
              <a key={a.label} href={a.path}
                className={`flex items-center gap-3 p-4 rounded-xl border transition-all group ${ACAO[a.color]}`}>
                <a.icon size={20} className={ACAO_ICON[a.color]} />
                <span className="text-sm font-medium text-gray-700">{a.label}</span>
              </a>
            ))}
          </div>
        </div>
        <div className="bg-white rounded-2xl p-6 shadow-sm border border-gray-100">
          <h3 className="text-lg font-heading font-semibold text-gray-900 mb-4">Ecossistema</h3>
          <div className="flex items-center justify-center py-8">
            <div className="text-center">
              <div className="w-24 h-24 mx-auto rounded-full bg-gradient-to-br from-primary-100 to-accent-100 flex items-center justify-center mb-4">
                <Leaf size={40} className="text-primary-600" />
              </div>
              <p className="text-sm text-gray-500">{isAdmin ? 'A rede está crescendo!' : isLic ? 'Sua rede está crescendo!' : 'The Conect Energy'}</p>
              <p className="text-2xl font-heading font-bold text-primary-700 mt-1">
                {isAdmin ? `${licStats?.total_licenciados || 0} licenciados` : isLic ? `${licStats?.meus_indicados ?? licStats?.conexoes_diretas_ativas ?? 0} indicados` : `${cliStats?.total_clientes || 0} clientes`}
              </p>
            </div>
          </div>
        </div>
      </div>

      {isLic && (
        <p className="text-center text-[11px] text-gray-400 flex items-center justify-center gap-1.5 pt-1">
          <ShieldCheck size={13} className="text-emerald-500" /> Seus dados estão protegidos com segurança de ponta a ponta.
        </p>
      )}
    </div>
  )
}
